const routes = () => ({
  index: { path: '/', childs: [] },
  //inicio:{path:'/inicio' , previousPath: '/', childs:[]},
  personalData: { path: '/datos-personales', previousPath: '/', childs: [] },
  contracts: { path: '/contratacion-pago', previousPath: '/datos-personales', childs: [] },
  summary: { path: '/comprobante-adicionales', previousPath: '/contratacion-pago', childs: [] },
  landing: { path: process.env.REACT_APP_LANDING_URL },
  privateSite: { path: process.env.REACT_APP_PRIVATE_SITE },
});

export default routes;
